import { useQuery } from "@tanstack/react-query";

import { api } from "./client";

export type CredentialType = "token" | "jwt" | "mtls";

export interface AgentMigrationRow {
  agent_id: string;
  name: string;
  tenant_id: string;
  declared_credential_type: CredentialType;
  auth_method_observed?: CredentialType | null;
  last_seen?: string | null;
  online: boolean;
  in_sync: boolean;
}

export interface MigrationStatusResponse {
  items: AgentMigrationRow[];
  summary: {
    total: number;
    online: number;
    stale: number;
    in_sync: number;
    by_observed_method: Record<string, number>;
    safe_to_flip_legacy_off: boolean;
  };
}

export function useAgentMigrationStatus() {
  return useQuery({
    queryKey: ["edge-auth", "migration-status"],
    queryFn: async () => {
      const { data } = await api.get<MigrationStatusResponse>(
        "/api/v1/agents/migration-status",
      );
      return data;
    },
    refetchInterval: 30_000,
  });
}
